import * as React from "react";
import { Box, ButtonBase } from "@mui/material";
import { platformFonts, usePlatformColors } from "../tickitPlatformTheme";

/** HTML `.tabs` / `.tab-btn` */
export default function PlatformTabs({ tabs, value, onChange }) {
  const colors = usePlatformColors();
  return (
    <Box sx={{ borderBottom: `1.5px solid ${colors.border}`, mb: 2.5 }}>
      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          flexWrap: "nowrap",
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {tabs.map((tab) => {
          const active = value === tab.id;
          return (
            <ButtonBase
              key={tab.id}
              onClick={() => onChange(tab.id)}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                flexShrink: 0,
                px: { xs: 1.25, sm: 2 },
                py: 1.25,
                fontFamily: platformFonts.body,
                fontSize: "13.5px",
                fontWeight: 600,
                color: active ? colors.brand : colors.text3,
                borderBottom: active ? `2.5px solid ${colors.brand}` : "2.5px solid transparent",
                mb: "-2px",
                borderRadius: 0,
                transition: "all 0.2s",
                "&:hover": { color: active ? colors.brand : colors.text },
              }}
            >
              {tab.icon}
              {tab.label}
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
}
